import { Injectable } from '@angular/core';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { ModalController, Platform } from 'ionic-angular';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { DemoBarcodesPage } from './demo-barcodes';

@Injectable()
export class ScanProvider {

    constructor(
        private platform: Platform,
        private barcodeScanner: BarcodeScanner,
        public modalCtrl: ModalController
    ) {
    }

    public scan(): Observable<string> {
        if (this.platform.is('core')) {
            const subject = new Subject<string>();
            let modal = this.modalCtrl.create(DemoBarcodesPage, { subject: subject }, { enableBackdropDismiss: false });
            modal.present();

            return subject.asObservable();
        }

        const options = {
            showTorchButton: true,
            // formats: 'EAN_13,CODE_39'
        }
        return Observable.fromPromise(this.barcodeScanner.scan(options))
            .map(barcodeScanResult => {
                if (!barcodeScanResult || barcodeScanResult.cancelled) {
                    console.log('Scan cancelled');
                    return null;
                }
                console.log('Scan: ' + barcodeScanResult.format + ', ' + barcodeScanResult.text);
                return barcodeScanResult.text;
            })
    }
}



// WEBPACK FOOTER //
// ./src/providers/scan-provider/scan-provider.ts